import { Checkbox, FormCheckbox, type GridRenderCellParams } from '@shared/components';
import { useFormContext } from 'react-hook-form';

interface FormQBankStructureCVChildCheckboxProps extends GridRenderCellParams {
  disabled?: boolean;
}

export function FormQBankStructureCVChildCheckbox(
  props: Readonly<FormQBankStructureCVChildCheckboxProps>,
) {
  const { disabled: isDisabled = false, ...params } = props;
  const name = `contentIds.${params.row.id}.isVisible`;
  const formContext = useFormContext();

  return !isDisabled ? (
    <FormCheckbox name={name} />
  ) : (
    <Checkbox checked={formContext.watch(name)} disabled />
  );
}
